import React from 'react';
import { Carousel } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { NameLink } from '../../interfaces/lesson.interface';

import classes from './carousel.module.css';
import './carousel.css';

interface Props {
  videos: NameLink[];
}

export const CustomCarousel = ({ videos }: Props) => {
  return (
    <Carousel interval={null} className="custom-carousel">
      {videos.map((video, index) => (
        <Carousel.Item key={`${index}-${video.name}`}>
          <div className="player-wrapper">
            <ReactPlayer 
              src={video.link} 
              width="100%" 
              height="100%"
              controls
            />
          </div>
        </Carousel.Item>
      ))}

      {/* <Carousel.Item>
                <ReactPlayer 
                    url='https://www.youtube.com/watch?v=5M0vOhAei-8&ab_channel=%D0%A6%D1%96%D0%BA%D0%B0%D0%B2%D0%B0%D0%BD%D0%B0%D1%83%D0%BA%D0%B0'
                />
                <Carousel.Caption bsPrefix={classes.caption}>
                    <h3>2</h3>
                    <p>Назва відео</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <ReactPlayer 
                    url='https://www.youtube.com/watch?v=5M0vOhAei-8&ab_channel=%D0%A6%D1%96%D0%BA%D0%B0%D0%B2%D0%B0%D0%BD%D0%B0%D1%83%D0%BA%D0%B0'
                />
                <Carousel.Caption bsPrefix={classes.caption}>
                    <h3>3</h3>
                    <p>Назва відео</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <ReactPlayer 
                    url='https://www.youtube.com/watch?v=5M0vOhAei-8&ab_channel=%D0%A6%D1%96%D0%BA%D0%B0%D0%B2%D0%B0%D0%BD%D0%B0%D1%83%D0%BA%D0%B0'
                />
                <Carousel.Caption bsPrefix={classes.caption}>
                    <h3>4</h3>
                    <p>Назва відео</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <ReactPlayer 
                    url='https://www.youtube.com/watch?v=5M0vOhAei-8&ab_channel=%D0%A6%D1%96%D0%BA%D0%B0%D0%B2%D0%B0%D0%BD%D0%B0%D1%83%D0%BA%D0%B0'
                />
                <Carousel.Caption bsPrefix={classes.caption}>
                    <h3>5</h3>
                    <p>Назва відео</p>
                </Carousel.Caption>
            </Carousel.Item> */}
    </Carousel>
  );
};
